export default "__VITE_ASSET__31db057c__"